import { render } from "./Map.vue?vue&type=template&id=0b61363a"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import "./Map.vue?vue&type=style&index=0&id=0b61363a&lang=css"
script.render = render

export default script